export enum TypeLienCommercialisation {
  Diffuse = "Diffuse",
  Distribue = "Distribue",
  Diffusion_par = "Diffusion par",
  Distribution_par = "Distribution par",
  Diffuse_Distribue = "Diffuse-Distribue",
  Diffusion_Distribution_par = "Diffusion-Distribution par",
}

export function stringToTypeLienCommercialisation(i: string | undefined): TypeLienCommercialisation {
  switch (i) {
    case "001": return TypeLienCommercialisation.Diffuse
    case "003": return TypeLienCommercialisation.Distribue
    case "009": return TypeLienCommercialisation.Diffusion_par
    case "011": return TypeLienCommercialisation.Distribution_par
    case "015": return TypeLienCommercialisation.Diffuse_Distribue
    case "016": return TypeLienCommercialisation.Diffusion_Distribution_par
    default: throw new Error("Valeur non valide pour Type Lien Commercialisation");
  }
}